// components/common/Badge.js
import { Service } from '../../models/Service';

export function Badge({ 
  children, 
  variant = 'default',
  size = 'medium',
  dot = false,
  className = '',
  ...props 
}) {
  const baseClasses = 'inline-flex items-center font-medium rounded-full';
  
  const variantClasses = {
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-pink-100 text-pink-800',
    secondary: 'bg-purple-100 text-purple-800',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    danger: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800'
  };
  
  const sizeClasses = {
    small: 'px-2 py-0.5 text-xs',
    medium: 'px-2.5 py-0.5 text-sm',
    large: 'px-3 py-1 text-sm'
  };
  
  const badgeClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;
  
  return (
    <span className={badgeClasses} {...props}>
      {dot && (
        <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${getDotColor(variant)}`} />
      )}
      {children}
    </span>
  );
}

// Helper function to get dot colors
function getDotColor(variant) {
  const dotColors = {
    default: 'bg-gray-400',
    primary: 'bg-pink-400',
    secondary: 'bg-purple-400',
    success: 'bg-green-400',
    warning: 'bg-yellow-400',
    danger: 'bg-red-400',
    info: 'bg-blue-400'
  };
  
  return dotColors[variant] || dotColors.default;
}

// Specialized badge for skin types
export function SkinTypeBadge({ skinType }) {
  const skinTypeColors = {
    normal: 'success',
    dry: 'warning',
    oily: 'info',
    combination: 'secondary',
    sensitive: 'danger'
  };
  
  const variant = skinTypeColors[skinType] || 'default';
  
  return (
    <Badge variant={variant} size="small">
      {skinType}
    </Badge>
  );
}

// Specialized badge for service categories
export function CategoryBadge({ category, icon, categories = [] }) {
  const variant = Service.getCategoryColor(category, categories);
  const categoryIcon = icon || Service.getCategoryIcon(category, categories);
  
  return (
    <Badge variant={variant} size="small">
      {categoryIcon && <span className="mr-1">{categoryIcon}</span>}
      {Service.getCategoryLabel(category, categories)}
    </Badge>
  );
}